<script setup lang="ts">
import { ESprites, ESpritesCards, ESpritesUI } from '@/shared/enum/sprites.enum'
import SvgIcon from '../SvgIcon.vue'

const icons = [
  { files: ESprites.CARDS, name: ESpritesCards.VISA, width: 70, height: 23 },
  { files: ESprites.CARDS, name: ESpritesCards.MASTERCARD, width: 37, height: 23 },
  { files: ESprites.CARDS, name: ESpritesCards.AMEX, width: 49, height: 30 },
  { files: ESprites.UI, name: ESpritesUI.HTECH, width: 79, height: 21 }
]
</script>

<template>
  <span
    class="flex flex-row justify-center flex-grow space-x-3"
    temprop="paymentAccepted"
    itemscope
    itemtype="https://schema.org/LoanOrCredit"
  >
    <svg-icon
      v-for="icon in icons"
      :key="icon.name"
      :file="icon.files"
      :name="icon.name"
      :width="icon.width"
      :height="icon.height"
    />
  </span>
</template>

<style scoped></style>
